import React, { useState } from "react";
import { isEmpty } from "lodash";
// hooks
import usePages from "@/hooks/usePages";
import useMenuItems from "@/hooks/useMenuItems";
// components
import RMDRLink from "@/components/RMDRLink";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    menuNameDescriptionLanguageVersion,
    pageNameDescriptionLanguageVersion, 
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
// types
import TClientPageList from "@/cms/types/TClientPageList";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// types
import { TMainPageLayoutV2 } from "../type";
// enums
import EContentType from "@/cms/enums/EContentType";


const RenderComponent = ( props:any ) => {

    return (
        <div
            className="col-xl-2 col-md-6"
            data-aos-duration="800"
            data-aos="fade-up"
            data-aos-delay="500"
        >
            <div className="single-footer-widget">
                <div className="widget-head">
                    <h3>{props.parentLanguageVersion?.name}</h3>
                </div>
                {props.children}
            </div>
        </div>
    )

}

const RenderItems = (props:{ payload:TClientPageList[]|TClientMenuItemList[]|TClientMainPageItemList[]|null, languageVersionSelector:any, template?:TClientMainPageItemList }) => {

    if ( !props.payload || isEmpty(props.payload) ) return null;

    return (
        <ul className="list-area">
            {
                props.payload.map((item:any) => {
                    const itemLanguageVersion = props.languageVersionSelector(item.languageVersions);
                    const itemRedirectUrl = redirectUrl(item.languageVersions);
                    const hasDestinationNavigation = props.template ? props.template.hasDestinationNavigation : item.hasDestinationNavigation;
                    const redirectType = props.template ? props.template.redirectType : item.redirectType;

                    return (
                        <li key={item.id}>
                            <RMDRLink
                                title={itemLanguageVersion?.name}
                                hasNavigationDestination={hasDestinationNavigation}
                                navigationURL={itemLanguageVersion?.contentRouteNavigationURL}
                                redirectType={redirectType}
                                redirectUrl={itemRedirectUrl?.value}
                                isShowAlways={true}
                                variant="span"
                                className="tw-line-clamp-1"
                            >
                                <i className="fa-solid fa-chevron-right" />
                                {itemLanguageVersion?.name}
                            </RMDRLink>
                        </li>
                    )
                })
            }
        </ul>
    )

}

const RenderPages = (props:any) => {

    const pages = usePages({unqKey:props.unqKey, categoryId:props.categoryId});
    
    if ( !isEmpty(pages) && pages ) {
        return (
            <RenderComponent className={pages.length<6?"line-widget-2":null} parentLanguageVersion={props.parentLanguageVersion}>
                <RenderItems payload={pages} template={props.template} languageVersionSelector={pageNameDescriptionLanguageVersion} />
            </RenderComponent>
        )
    }

    return null;
}

const RenderMenuItems = (props:any) => {

    const menuItems = useMenuItems(props.unqKey, props.contentLayoutName);

    if ( !isEmpty(menuItems) && menuItems ) {
        return (
            <RenderComponent className={menuItems.length<6?"line-widget-2":null} parentLanguageVersion={props.parentLanguageVersion}>
                <RenderItems payload={menuItems} template={props.template} languageVersionSelector={menuNameDescriptionLanguageVersion} />
            </RenderComponent>
        )
    }

    return null;
}

const MNPG009 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG009.rendered: ", props);
    const [parentLanguageVersion] = useState(mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions));

    if ( !props.template || !props.templates ) return null;

    if ( props.template.isContentChildsMapped ) {
        const childs = props.templates.filter((item) => ![EContentType.MAP,EContentType.SITE_SETTING].includes(item?.contentType as number) && item.parentId === props.template?.id);
        if ( !isEmpty(childs) ) {
            return (
                <RenderComponent className={childs.length<6?"line-widget-2":null} parentLanguageVersion={parentLanguageVersion} >
                    <RenderItems payload={childs} languageVersionSelector={mainPageItemNameDescriptionLanguageVersion} />
                </RenderComponent>
            )
        }
    }
    else {
        const mapItem = props.templates.find((item) => item.contentType === EContentType.MAP && item.contentLayoutName?.startsWith("MNGRP_") && item.parentId === props.template?.id);
        if ( mapItem ) {
            return (<RenderMenuItems unqKey={mapItem.id.split("-")[4]} template={mapItem} contentLayoutName={mapItem.contentLayoutName} parentLanguageVersion={parentLanguageVersion} />)
        }

        const categoryItem = props.templates.find((item) => item.contentType === EContentType.CATEGORY && item.parentId === props.template?.id);
        if ( categoryItem ) {
            return (<RenderPages unqKey={categoryItem.id.split("-")[4]} template={categoryItem} categoryId={categoryItem.contentId} parentLanguageVersion={parentLanguageVersion} />)
        }
    }

    return null;
}

const Component = React.memo(MNPG009, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    return true;
});

export default Component;
